import React, { useState, FormEvent } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import MobileMenu from "../MobileMenu/MobileMenu";
import { totalPrice } from "../../utils";
import Logo from "../../images/logo-2.svg";
import { removeFromCart } from "../../store/actions/action";

// 🧾 Type definitions
interface CartItem {
  id: number;
  title: string;
  price: number;
  qty: number;
  proImg: string;
}

interface Header2Props {
  topbarNone?: string;
  hclass?: string;
  carts: CartItem[];
  removeFromCart: (id: number) => void;
}

const Header2: React.FC<Header2Props> = ({
  topbarNone,
  hclass,
  carts,
  removeFromCart,
}) => {
  const [menuActive, setMenuState] = useState(false);
  const [cartActive, setCartState] = useState(false);

  const SubmitHandler = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
  };

  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };

  return (
    <header id="header" className={topbarNone}>
      <div className={`wpo-site-header ${hclass || ""}`}>
        <nav className="navigation navbar navbar-expand-lg navbar-light">
          <div className="container-fluid">
            <div className="row align-items-center">
              {/* Mobile Menu */}
              <div className="col-lg-3 col-md-3 col-3 d-lg-none dl-block">
                <div className="mobail-menu">
                  <MobileMenu />
                </div>
              </div>

              {/* Logo */}
              <div className="col-lg-2 col-md-6 col-6">
                <div className="navbar-header">
                  <Link onClick={ClickHandler} className="navbar-brand" to="/home">
                    <img src={Logo} alt="Logo" />
                  </Link>
                </div>
              </div>

              {/* Main Menu */}
              <div className="col-lg-8 col-md-1 col-1">
                <div
                  id="navbar"
                  className="site-navbar collapse navbar-collapse navigation-holder"
                >
                  <button className="menu-close">
                    <i className="ti-close"></i>
                  </button>

                  <ul className="nav navbar-nav mb-2 mb-lg-0">
                    {/* Home */}
                    <li className="menu-item-has-children">
                      <Link onClick={ClickHandler} to="/">Home</Link>
                      <ul className="sub-menu">
                        <li><Link onClick={ClickHandler} to="/home">Wedding Home Style 1</Link></li>
                        <li><Link onClick={ClickHandler} to="/home-2">Wedding Home Style 2</Link></li>
                        <li><Link onClick={ClickHandler} to="/home-3">Wedding Home Style 3</Link></li>
                        <li><Link onClick={ClickHandler} to="/home-4">Wedding Planner Style 1</Link></li>
                        <li><Link onClick={ClickHandler} to="/home-5">Wedding Planner Style 2</Link></li>
                        <li><Link onClick={ClickHandler} to="/home-6">Wedding Shop Home</Link></li>
                        <li><Link onClick={ClickHandler} to="/invitation">Wedding Invitation</Link></li>
                      </ul>
                    </li>

                    {/* Pages */}
                    <li className="menu-item-has-children">
                      <Link onClick={ClickHandler} to="/">Pages</Link>
                      <ul className="sub-menu">
                        <li><Link onClick={ClickHandler} to="/about">About</Link></li>

                        <li className="menu-item-has-children">
                          <Link onClick={ClickHandler} to="/story">Our Story</Link>
                          <ul className="sub-menu">
                            <li><Link onClick={ClickHandler} to="/story">Our Story Style 1</Link></li>
                            <li><Link onClick={ClickHandler} to="/story-2">Our Story Style 2</Link></li>
                            <li><Link onClick={ClickHandler} to="/story-3">Our Story Style 3</Link></li>
                          </ul>
                        </li>

                        <li><Link onClick={ClickHandler} to="/accomodation">Accomodation</Link></li>

                        <li className="menu-item-has-children">
                          <Link onClick={ClickHandler} to="/rsvp">RSVP</Link>
                          <ul className="sub-menu">
                            <li><Link onClick={ClickHandler} to="/rsvp">RSVP Style 1</Link></li>
                            <li><Link onClick={ClickHandler} to="/rsvp-2">RSVP Style 2</Link></li>
                            <li><Link onClick={ClickHandler} to="/rsvp-3">RSVP Style 3</Link></li>
                          </ul>
                        </li>

                        <li><Link onClick={ClickHandler} to="/gallery">Gallery</Link></li>
                        <li><Link onClick={ClickHandler} to="/planner">Planners</Link></li>
                        <li><Link onClick={ClickHandler} to="/team-single/Annette-Black">Planner Single</Link></li>
                        <li><Link onClick={ClickHandler} to="/groom-bride">Brides & Grooms</Link></li>

                        <li className="menu-item-has-children">
                          <Link onClick={ClickHandler} to="/service">Service</Link>
                          <ul className="sub-menu">
                            <li><Link onClick={ClickHandler} to="/service">Service</Link></li>
                            <li><Link onClick={ClickHandler} to="/service-single/Wedding-Dress">Service Single</Link></li>
                          </ul>
                        </li>

                        <li><Link onClick={ClickHandler} to="/pricing">Pricing</Link></li>

                        <li className="menu-item-has-children">
                          <Link onClick={ClickHandler} to="/">Auth Pages</Link>
                          <ul className="sub-menu">
                            <li><Link onClick={ClickHandler} to="/login">Login</Link></li>
                            <li><Link onClick={ClickHandler} to="/register">Register</Link></li>
                            <li><Link onClick={ClickHandler} to="/forgot">Forgot Password</Link></li>
                          </ul>
                        </li>

                        <li><Link onClick={ClickHandler} to="/coming">Coming Soon</Link></li>
                        <li><Link onClick={ClickHandler} to="/404">404 Error</Link></li>
                      </ul>
                    </li>

                    {/* Portfolio */}
                    <li className="menu-item-has-children">
                      <Link onClick={ClickHandler} to="/portfolio-grid">Portfolio</Link>
                      <ul className="sub-menu">
                        <li><Link onClick={ClickHandler} to="/portfolio-grid">Portfolio Grid</Link></li>
                        <li><Link onClick={ClickHandler} to="/portfolio-grid-s2">Portfolio Grid S2</Link></li>
                        <li><Link onClick={ClickHandler} to="/portfolio-slide">Portfolio Slide</Link></li>
                        <li><Link onClick={ClickHandler} to="/portfolio-masonary">Portfolio Masonary</Link></li>
                        <li><Link onClick={ClickHandler} to="/project-single/James-Amelia">Portfolio Single</Link></li>
                      </ul>
                    </li>

                    {/* Shop */}
                    <li className="menu-item-has-children">
                      <Link onClick={ClickHandler} to="/shop">Shop</Link>
                      <ul className="sub-menu">
                        <li><Link onClick={ClickHandler} to="/shop">Shop</Link></li>
                        <li><Link onClick={ClickHandler} to="/product-single/Stylish-Designer-Gown">Shop Single</Link></li>
                        <li><Link onClick={ClickHandler} to="/cart">Cart</Link></li>
                        <li><Link onClick={ClickHandler} to="/wishlist">Wishlist</Link></li>
                        <li><Link onClick={ClickHandler} to="/checkout">Checkout</Link></li>
                      </ul>
                    </li>

                    {/* Blog */}
                    <li className="menu-item-has-children">
                      <Link onClick={ClickHandler} to="/blog">Blog</Link>
                      <ul className="sub-menu">
                        <li><Link onClick={ClickHandler} to="/blog">Blog right sidebar</Link></li>
                        <li><Link onClick={ClickHandler} to="/blog-left-sidebar">Blog left sidebar</Link></li>
                        <li><Link onClick={ClickHandler} to="/blog-fullwidth">Blog fullwidth</Link></li>
                        <li className="menu-item-has-children">
                          <Link onClick={ClickHandler} to="/">Blog details</Link>
                          <ul className="sub-menu">
                            <li><Link onClick={ClickHandler} to="/blog-single/You-Must-Need-a-Great-Photographer">Blog details right sidebar</Link></li>
                            <li><Link onClick={ClickHandler} to="/blog-single-left-sidebar/You-Must-Need-a-Great-Photographer">Blog details left sidebar</Link></li>
                            <li><Link onClick={ClickHandler} to="/blog-single-fullwidth/You-Must-Need-a-Great-Photographer">Blog details fullwidth</Link></li>
                          </ul>
                        </li>
                      </ul>
                    </li>

                    {/* Contact */}
                    <li><Link onClick={ClickHandler} to="/contact">Contact</Link></li>
                  </ul>
                </div>
              </div>

              {/* Right Section (Search + Cart) */}
              <div className="col-lg-2 col-md-2 col-2">
                <div className="header-right">
                  {/* Search */}
                  <div className="header-search-form-wrapper">
                    <div className="cart-search-contact">
                      <button
                        onClick={() => setMenuState(!menuActive)}
                        className="search-toggle-btn"
                      >
                        <i
                          className={`fi ti-search ${menuActive ? "ti-close" : "ti-search"
                            }`}
                        ></i>
                      </button>

                      <div
                        className={`header-search-form ${menuActive ? "header-search-content-toggle" : ""
                          }`}
                      >
                        <form onSubmit={SubmitHandler}>
                          <div>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Search here..."
                            />
                            <button type="submit">
                              <i className="fi ti-search"></i>
                            </button>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>

                  {/* Cart */}
                  <div className="mini-cart">
                    <button
                      className="cart-toggle-btn"
                      onClick={() => setCartState(!cartActive)}
                    >
                      <i className="fi flaticon-shopping-cart"></i>
                      <span className="cart-count">{carts.length}</span>
                    </button>

                    <div
                      className={`mini-cart-content ${cartActive ? "mini-cart-content-toggle" : ""
                        }`}
                    >
                      <button
                        className="mini-cart-close"
                        onClick={() => setCartState(!cartActive)}
                      >
                        <i className="ti-close"></i>
                      </button>

                      <div className="mini-cart-items">
                        {carts &&
                          carts.length > 0 &&
                          carts.map((catItem, index) => (
                            <div className="mini-cart-item clearfix" key={index}>
                              <div className="mini-cart-item-image">
                                <span>
                                  <img src={catItem.proImg} alt="cart item" />
                                </span>
                              </div>

                              <div className="mini-cart-item-des">
                                <p>{catItem.title}</p>
                                <span className="mini-cart-item-price">
                                  ${catItem.price} × {catItem.qty}
                                </span>
                                <span className="mini-cart-item-quantity">
                                  <button
                                    onClick={() => removeFromCart(catItem.id)}
                                    className="btn btn-sm btn-danger"
                                  >
                                    <i className="ti-close"></i>
                                  </button>
                                </span>
                              </div>
                            </div>
                          ))}
                      </div>

                      <div className="mini-cart-action clearfix">
                        <span className="mini-checkout-price">
                          Subtotal: <span>${totalPrice(carts)}</span>
                        </span>
                        <div className="mini-btn">
                          <Link
                            onClick={ClickHandler}
                            to="/checkout"
                            className="view-cart-btn s1"
                          >
                            Checkout
                          </Link>
                          <Link
                            onClick={ClickHandler}
                            to="/cart"
                            className="view-cart-btn"
                          >
                            View Cart
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* End Right Section */}
            </div>
          </div>
        </nav>
      </div>
    </header>
  );
};

// Redux map state
const mapStateToProps = (state: any) => ({
  carts: state.cartList.cart,
});

export default connect(mapStateToProps, { removeFromCart })(Header2);
